import { useState, useEffect } from 'react';
import useEventFromAPI from '@hooks/apiLegacy/useEventFromAPI';

const useEventPrices = ({ eventCode }) => {
    const [memberPrice, setMemberPrice] = useState();
    const [nonMemberPrice, setNonMemberPrice] = useState();
    const { event } = useEventFromAPI({ code: eventCode });

    useEffect(() => {
        if (!event) {
            return;
        }

        const fullProgram = event.functions.find(func => func.code === 'FP');
        const memberFee = fullProgram.fees.find(fee => fee.registrant_class === 'M');
        const nonMemberFee = fullProgram.fees.find(fee => fee.registrant_class === 'NM');

        setMemberPrice(memberFee?.price || null);
        setNonMemberPrice(nonMemberFee?.price || null);
    }, [event]);

    return { memberPrice, nonMemberPrice };
};

export default useEventPrices;
